import React from "react";
import "./SectionDivider.css";

const SectionDivider = ({ title }) => {
    return (
        <div className="divider-container1 my-4">
            <span className="section-title1">{title}</span>
        </div>
    );
};

export default SectionDivider;
